import { Validators } from "@angular/forms";

export function quantityGroup (fb: any):any {
    return fb.group({
        //at least 1 adult
        adult: ['', [Validators.required, Validators.min(1)]],
        child: ['', Validators.required],
        infant: ['', Validators.required],
        rooming: ['']
    });
}
